export const stageOfConstructionSchema = {
	schema: {
		title: 'stage of construction schema',
		version: 0,
		primaryKey: 'code',
		type: 'object',
		properties: {
			code: { type: 'string', maxLength: 250 },
			name: { type: 'string' },
			image: { type: 'string' },
			applicable_surfaces: {
				type: 'array',
				items: {
					type: 'object',
					properties: {
						code: { type: 'string' },
						name: { type: 'string' },
						image: { type: 'string' },
						is_rr_required: { type: 'boolean' },
						project_classifications: {
							type: 'array',
							items: {
								type: 'object',
								properties: {
									code: { type: 'string' },
									name: { type: 'string' },
									image: { type: 'string' },
								},
							},
						},
					},
				},
			},
		},
		required: ['code', 'name', 'applicable_surfaces'],
	},
};
